export default __webpack_public_path__ + "static/media/restoreActive.65e2f74f.svg";